//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as orderTagApi from '@/api/orderTagApi.js';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      editId: '',
      brandOption: []
    };
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(editId) {
      var _this = this;
      this.editId = editId;
      this.pram = {};
      if (!this.editId) {
        this.visible = true;
        return;
      }
      ;
      orderTagApi.getComDetail(editId).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _this.visible = true;
        _this.pram = res;
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _ref = _this2.pram || {},
          tagName = _ref.tagName,
          status = _ref.status;
        orderTagApi[_this2.editId && _this2.editId != 0 ? 'UpdateArticle' : 'AddArticle']({
          id: _this2.editId,
          tagName: tagName,
          status: status
        }).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};